// Bowling Green State University's undergraduate majors (#2743). Read on
// 2026-10-01 from the official 2026-2027 Undergraduate Catalog
// (catalog.bgsu.edu, catoid=25), its Colleges page, which lists every
// program under the college that offers it. Kept: each program whose name
// ends in a bachelor's degree abbreviation, named as the catalog names it
// with the degree moved to its own field (B.A., B.S., BSBA, BSED, ...);
// specializations stay separate, as the catalog lists them. Left out:
// minors, certificates, associate degrees, preprofessional preparation, the
// "Multidisciplinary Component", the catalog's degree-requirement pages
// ("Bachelor of Arts Degree" and the like, which are not majors), the online
// Criminal Justice (eCampus) program, the Nursing RN/BSN and Medical
// Laboratory Science (MLT to MLS) completion programs for credentialed
// students, and the BGSU Firelands (Huron, Ohio) regional campus programs,
// since this page covers the main campus. The catalog sits behind a browser
// check, so it was read in a browser. One official name, "Artificial
// Intelligence (AI) + X", keeps its own wording. The KB's majors list was
// the starting point; the catalog wins.
const majors = {
    "slug": "bowling-green-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in BGSU's official 2026-2027 Undergraduate Catalog for the Bowling Green campus, grouped by the college that offers it, with the degree it leads to. BGSU lists each specialization as its own program, and so does this list. Minors, certificates, associate degrees, online-only and degree-completion programs, and BGSU Firelands programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "BGSU 2026-2027 Undergraduate Catalog, Colleges",
                "url": "https://catalog.bgsu.edu/content.php?catoid=25&navoid=2048"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "B.A."
                },
                {
                    "name": "Art Education",
                    "degree": "BFA"
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art, Specialization in Digital Arts",
                    "degree": "B.A."
                },
                {
                    "name": "Art, Specialization in Studio",
                    "degree": "B.A."
                },
                {
                    "name": "Artificial Intelligence (AI) + X",
                    "degree": "B.S."
                },
                {
                    "name": "Bachelor of Liberal Studies",
                    "degree": "BLS"
                },
                {
                    "name": "Bachelor of Science In Fire Administration",
                    "degree": "BSFA"
                },
                {
                    "name": "Bachelor of Science in Journalism, Specialization in Public Relations",
                    "degree": "BSJ"
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology, Specialization in Ecology and Conservation Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology, Specialization in Marine and Aquatic Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology, Specialization in Marine and Aquatic Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology, Specialization in Pre-Health",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry, Specialization in Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Communication",
                    "degree": "BAC"
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science, Specialization in Computational Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science, Specialization in Cybersecurity",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science, Specialization in Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Creative Writing",
                    "degree": "BFA"
                },
                {
                    "name": "Digital Arts",
                    "degree": "BFA"
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies, Environmental Resilience and Climate Change Specialization",
                    "degree": "B.A."
                },
                {
                    "name": "Film",
                    "degree": "B.A."
                },
                {
                    "name": "Forensic Science, Specialization in Forensic DNA Analysis",
                    "degree": "B.S."
                },
                {
                    "name": "Forensic Science, Specialization in Forensic Drug Analysis",
                    "degree": "B.S."
                },
                {
                    "name": "Forensic Science, Specialization in Forensic Examination",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Geology, Specialization in Paleobiology",
                    "degree": "B.S."
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Individualized Planned Program",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics, Specialization in Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics, Specialization in Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics, Specialization in Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Media Production and Studies, Specialization in Media Production",
                    "degree": "B.A."
                },
                {
                    "name": "Media Production and Studies, Specialization in Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy, Politics, Economics, and Law (PPEL)",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy, Politics, Economics, and Law (PPEL), Specialization in Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Studio",
                    "degree": "BFA"
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "BAC"
                },
                {
                    "name": "Theatre, Specialization in Acting/Directing",
                    "degree": "BAC"
                },
                {
                    "name": "Theatre, Specialization in Design/Technical Theatre",
                    "degree": "BAC"
                },
                {
                    "name": "Theatre, Specialization in Musical Theatre",
                    "degree": "BAC"
                },
                {
                    "name": "Theatre, Specialization in Youth Theatre",
                    "degree": "BAC"
                },
                {
                    "name": "World Languages and Cultures, Specialization in Classics",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures, Specialization in French",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures, Specialization in German",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures, Specialization in Latin American Culture Studies",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures, Specialization in Russian",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures, Specialization in Spanish",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Allen W. and Carol M. Schmidthorst College of Business",
            "source": {
                "label": "BGSU 2026-2027 Undergraduate Catalog, Colleges",
                "url": "https://catalog.bgsu.edu/content.php?catoid=25&navoid=2048"
            },
            "majors": [
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Applied Business Economics",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Business Analytics and Intelligence",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Human Resource Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Individualized Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Information Systems",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in International Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Risk Management and Insurance",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Sales and Services Marketing",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Business Administration, Specialization in Supply Chain Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Bachelor of Science in Economics",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "BGSU 2026-2027 Undergraduate Catalog, Colleges",
                "url": "https://catalog.bgsu.edu/content.php?catoid=25&navoid=2048"
            },
            "majors": [
                {
                    "name": "Adolescence to Young Adult/Secondary Education",
                    "degree": "BSED"
                },
                {
                    "name": "Adolescence to Young Adult/Secondary Education, Specialization in Integrated Language Arts",
                    "degree": "BSED"
                },
                {
                    "name": "Adolescence to Young Adult/Secondary Education, Specialization in Integrated Mathematics",
                    "degree": "BSED"
                },
                {
                    "name": "Adolescence to Young Adult/Secondary Education, Specialization in Integrated Science",
                    "degree": "BSED"
                },
                {
                    "name": "Adolescence to Young Adult/Secondary Education, Specialization in Integrated Social Studies",
                    "degree": "BSED"
                },
                {
                    "name": "Bachelor of Science in Human Development and Family Science",
                    "degree": "BSHDFS"
                },
                {
                    "name": "Bachelor of Science in Interior Design",
                    "degree": "BSID"
                },
                {
                    "name": "Career Tech Workforce Education",
                    "degree": "BSED"
                },
                {
                    "name": "Career Tech Workforce Education, Specialization in Business and Marketing Education",
                    "degree": "BSED"
                },
                {
                    "name": "Career Tech Workforce Education, Specialization in Family and Consumer Sciences Education",
                    "degree": "BSED"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BSED"
                },
                {
                    "name": "Fashion Merchandising and Product Development",
                    "degree": "BSFMPD"
                },
                {
                    "name": "Inclusive PreK-5 Education",
                    "degree": "BSED"
                },
                {
                    "name": "Individualized Studies",
                    "degree": "BSED"
                },
                {
                    "name": "Middle Childhood Education",
                    "degree": "BSED"
                },
                {
                    "name": "Physical Education and Health Education",
                    "degree": "BSED"
                },
                {
                    "name": "Special Education",
                    "degree": "BSED"
                },
                {
                    "name": "Sport Management",
                    "degree": "BSED"
                },
                {
                    "name": "Tourism, Hospitality, and Event Management",
                    "degree": "BSED"
                }
            ]
        },
        {
            "name": "College of Health and Human Services",
            "source": {
                "label": "BGSU 2026-2027 Undergraduate Catalog, Colleges",
                "url": "https://catalog.bgsu.edu/content.php?catoid=25&navoid=2048"
            },
            "majors": [
                {
                    "name": "Allied Health",
                    "degree": "BSAH"
                },
                {
                    "name": "Applied Health Science, Specialization in Allied Health",
                    "degree": "BAHS"
                },
                {
                    "name": "Applied Health Science, Specialization in Health Science",
                    "degree": "BAHS"
                },
                {
                    "name": "Applied Health Science, Specialization in Pre-pharmacy",
                    "degree": "BAHS"
                },
                {
                    "name": "Bachelor of Science in Dietetics",
                    "degree": "BSD"
                },
                {
                    "name": "Bachelor of Science in Health Care Administration",
                    "degree": "BSHCA"
                },
                {
                    "name": "Bachelor of Science in Health Care Administration, Specialization in Long Term Care",
                    "degree": "BSHCA"
                },
                {
                    "name": "Bachelor of Science in Medical Laboratory Science",
                    "degree": "BSMLS"
                },
                {
                    "name": "Bachelor of Science in Public Health, Concentration in Environmental Health",
                    "degree": "BSPH"
                },
                {
                    "name": "Bachelor of Science in Public Health, Concentration in Health Promotion",
                    "degree": "BSPH"
                },
                {
                    "name": "Bachelor of Science in Social Work",
                    "degree": "BSSW"
                },
                {
                    "name": "Communication Disorders",
                    "degree": "BSCD"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BSCJ"
                },
                {
                    "name": "Criminal Justice, Specialization in Forensic Investigations",
                    "degree": "BSCJ"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "College of Musical Arts",
            "source": {
                "label": "BGSU 2026-2027 Undergraduate Catalog, Colleges",
                "url": "https://catalog.bgsu.edu/content.php?catoid=25&navoid=2048"
            },
            "majors": [
                {
                    "name": "Bachelor of Arts in Music Industry",
                    "degree": "BAMI"
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education, Specialization in Choral",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education, Specialization in Classroom/General Music",
                    "degree": "B.M."
                },
                {
                    "name": "Music Education, Specialization in Instrumental",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance, Specialization in Instrumental",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance, Specialization in Jazz",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance, Specialization in Piano",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance, Specialization in Vocal Pedagogy",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance, Specialization in Voice",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance, Specialization in Woodwind Specialist",
                    "degree": "B.M."
                },
                {
                    "name": "World Music",
                    "degree": "B.M."
                }
            ]
        },
        {
            "name": "College of Engineering and Innovation",
            "source": {
                "label": "BGSU 2026-2027 Undergraduate Catalog, Colleges",
                "url": "https://catalog.bgsu.edu/content.php?catoid=25&navoid=2048"
            },
            "majors": [
                {
                    "name": "Architecture and Environmental Design",
                    "degree": "BSArch"
                },
                {
                    "name": "Aviation Studies",
                    "degree": "BSAvi"
                },
                {
                    "name": "Aviation Studies, Specialization in Aviation Management and Operations",
                    "degree": "BSAvi"
                },
                {
                    "name": "Aviation Studies, Specialization in Flight Technology and Operations",
                    "degree": "BSAvi"
                },
                {
                    "name": "Bachelor of Science in Aviation Flight Operations",
                    "degree": "BSAFO"
                },
                {
                    "name": "Bachelor of Science in Aviation Management",
                    "degree": "BSAVM"
                },
                {
                    "name": "Construction Management",
                    "degree": "BSCM"
                },
                {
                    "name": "Electronics and Computer Engineering",
                    "degree": "BSECE"
                },
                {
                    "name": "Engineering Technology",
                    "degree": "BSET"
                },
                {
                    "name": "Management and Technology",
                    "degree": "BST"
                },
                {
                    "name": "Mechanical and Manufacturing Engineering",
                    "degree": "BSMME"
                },
                {
                    "name": "Quality Systems",
                    "degree": "BST"
                },
                {
                    "name": "Robotics Engineering",
                    "degree": "BSROBO"
                },
                {
                    "name": "Systems Engineering",
                    "degree": "BSSE"
                },
                {
                    "name": "Visual Communication Technology",
                    "degree": "BST"
                }
            ]
        }
    ]
};

export default majors;
